import { render, staticRenderFns } from "./StepTabTerms.vue?vue&type=template&id=0dc88660&scoped=true"
import script from "./StepTabTerms.vue?vue&type=script&lang=js"
export * from "./StepTabTerms.vue?vue&type=script&lang=js"
import style0 from "./StepTabTerms.vue?vue&type=style&index=0&id=0dc88660&prod&scoped=true&lang=css"
import style1 from "./StepTabTerms.vue?vue&type=style&index=1&id=0dc88660&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc88660",
  null
  
)

export default component.exports